import React, { useState, useEffect, useMemo } from 'react';
import {

  Box,
  Paper,
  Typography,
  Button,
  TextField,
  Chip,
  IconButton,
  Stack,
  Grid,
  Alert,
  Skeleton,
  CssBaseline,
  Container,
  alpha,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Card,
  CardContent,
  Tooltip,
  capitalize
} from '@mui/material';
import {
  Search as SearchIcon,
  Clear as ClearIcon,
  Visibility as ViewIcon,
  Receipt as ReceiptIcon,
  CheckCircle as CheckIcon,
  Pending as PendingIcon,
  Refresh as RefreshIcon,
  RemoveRedEyeOutlined,
  CheckCircleOutlineOutlined
} from '@mui/icons-material';

import AppNavbar from '../../../../components/AppNavbar';
import Header from '../../../../components/Header';
import SideMenu from '../../../../components/SideMenu';
import { StyledCellHeader } from '../../../../components/StyledCellHeader';
import {
  chartsCustomizations,
  dataGridCustomizations,
  datePickersCustomizations,
  treeViewCustomizations,
} from '../../../dashboard/theme/customizations';
import AppTheme from '../../../../shared-theme/AppTheme';
import Selector from '../../../../components/Selector';
import { useParams } from 'react-router-dom';
import AlertMessageDialog from '../../../../components/Dialogs/alertMessageDialog';


const xThemeComponents = {
  ...chartsCustomizations,
  ...dataGridCustomizations,
  ...datePickersCustomizations,
  ...treeViewCustomizations,
};





const ESTADOS = {
  pendiente: { label: 'Pendiente', color: 'warning', icon: <PendingIcon /> },
  recibido: { label: 'Recibido', color: 'success', icon: <CheckIcon /> }
};

const GestionComercialCargos = (props) => {
  // State management
  const [productos, setProductos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [gestionCargos, setGestionCargos] = useState([]);
  const [cargoDetalle, setCargoDetalle] = useState(null);
  const { id } = useParams();
  
  // Alert dialog state
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertTitle, setAlertTitle] = useState('');
  const [alertSeverity, setAlertSeverity] = useState('success');

  
  // Filters state
  const [filters, setFilters] = useState({
    search: '',
    estado: '',
    sucursal: ''
  });
  
  // Dialog states
  const [showReceptionDialog, setShowReceptionDialog] = useState(false);
  const [selectedCargo, setSelectedCargo] = useState(null);
  
  // Reception dialog state
  const [receptionData, setReceptionData] = useState({
    numeracion: '',
    comentario: ''
  });


  
  // Load data
  useEffect(() => {

    fetchCargo();
    fetchGestionCargo();
  }, []);
  
  const fetchGestionCargo = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/gestion_cargos/${localStorage.getItem('idcompany')}`,
        {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'X-Usuario-ID': localStorage.getItem('id'),
              'X-company-ID': localStorage.getItem('idcompany')
            }
        }
      );
      const data = await response.json();
      setGestionCargos(data);
    } catch (error) {
      showAlert(
        'Error de Conexión',
        'No se pudo cargar la información de gestión de cargos',
        'error'
      );
    }
  };


  const fetchCargo = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/categorias_cargos/${id}`,
        {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'X-Usuario-ID': localStorage.getItem('id'),
              'X-company-ID': localStorage.getItem('idcompany')
            }
        }
      );
      const data = await response.json();
      setProductos(data['productos']);
      setCargoDetalle(data);
      setLoading(false);
    } catch (error) {
      showAlert(
        'Error de Conexión',
        'No se pudo cargar la información del cargo',
        'error'
      );
      setLoading(false);
    }
  };

  // Function to show alert messages
  const showAlert = (title, message, severity = 'success') => {
    setAlertTitle(title);
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };

  // Function to close alert
  const handleCloseAlert = () => {
    setAlertOpen(false);
  };
  // Filtered data


  const filteredProductos = useMemo(() => {
    return productos.filter(producto => {
      const matchesSearch = !filters.search || 
        producto.id.toLowerCase().includes(filters.search.toLowerCase()) ||
        producto.categoria_name.toLowerCase().includes(filters.search.toLowerCase());
      const matchesEstado = !filters.estado || producto.estado === filters.estado;
      const matchesSucursal = !filters.sucursal || producto.sucursal === filters.sucursal;
      
      return matchesSearch && matchesEstado && matchesSucursal;
    });
  }, [productos, filters]);
  
  // Event handlers
  const handleReception = (cargo) => {
    setSelectedCargo(cargo);
    setReceptionData({
      numeracion: '',
      comentario: ''
    });
    setShowReceptionDialog(true);
  };
  
  const handleReceptionSubmit = async () => {
    try {
      const data_to_send = {
        id_cargo: cargoDetalle.id,
        id_sucursal: localStorage.getItem('id_sucursal'),
        id_usuario: localStorage.getItem('id'),
        id_producto: selectedCargo.id,
        id_company: localStorage.getItem('idcompany'),
        estado: 'recibido',
        fecha_recepcion: new Date().toISOString().slice(0, 19).replace('T', ' '),
        observaciones: receptionData.comentario,
        organizacion: {}
      };
      
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/gestion_cargos`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Usuario-ID': localStorage.getItem('id'),
            'X-company-ID': localStorage.getItem('idcompany')
          },
          body: JSON.stringify(data_to_send)
        }
      );
      
      const data = await response.json();
      
      if (response.ok) {
        showAlert(
          'Recepción Exitosa',
          `El producto ${selectedCargo.id} ha sido recibido correctamente`,
          'success'
        );
        setShowReceptionDialog(false);
        setSelectedCargo(null);
        setReceptionData({ numeracion: '', comentario: '' });
        
        // Refresh data
        await fetchCargo();
        await fetchGestionCargo();
      } else {
        showAlert(
          'Error en la Recepción',
          data.message || 'Error al procesar la recepción del producto',
          'error'
        );
      }
    } catch (error) {
      showAlert(
        'Error de Conexión',
        'No se pudo conectar con el servidor. Verifique su conexión a internet.',
        'error'
      );
    }
  };
  
  const handleClearFilters = () => {
    setFilters({
      search: '',
      estado: '',
      sucursal: ''
    });
  };


  
  // Loading skeleton
  if (loading) {
    return (
      <AppTheme {...props} themeComponents={xThemeComponents}>
        <CssBaseline enableColorScheme />
        <Box sx={{ display: 'flex' }}>
          <SideMenu />
          <AppNavbar />
          <Box
            component="main"
            sx={(theme) => ({
              flexGrow: 1,
              backgroundColor: theme.vars
                ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
                : alpha(theme.palette.background.default, 1),
              overflow: 'auto',
            })}
          >
            <Stack
              spacing={2}
              sx={{
                alignItems: 'center',
                mx: 3,
                pb: 5,
                mt: { xs: 8, md: 0 },
              }}
            >
              <Header parent={"Gestión Comercial"} child={"Gestión de Cargos"} />
              <Container maxWidth={false} sx={{ px: 5, py: 5 }}>
                <Box sx={{ minHeight: '100vh', backgroundColor: '#fff', fontFamily: 'Inter, "Noto Sans", sans-serif' }}>
                  <Box maxWidth="lg" mx="auto" py={4}>
                    <Box sx={{ p: 3 }}>
                      <Skeleton variant="rectangular" height={60} sx={{ mb: 2 }} />
                      <Skeleton variant="rectangular" height={400} />
                    </Box>
                  </Box>
                </Box>
              </Container>
            </Stack>
          </Box>
        </Box>
      </AppTheme>
    );
  }
  
  return (
    <AppTheme {...props} themeComponents={xThemeComponents}>
      <CssBaseline enableColorScheme />
      <Box sx={{ display: 'flex' }}>
        <SideMenu />
        <AppNavbar />
        {/* Main content */}
        <Box
          component="main"
          sx={(theme) => ({
            flexGrow: 1,
            backgroundColor: theme.vars
              ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
              : alpha(theme.palette.background.default, 1),
            overflow: 'auto',
          })}
        >
          <Stack
            spacing={2}
            sx={{
              alignItems: 'center',
              mx: 3,
              pb: 5,
              mt: { xs: 8, md: 0 },
            }}
          >
            <Header parent={"Gestión Comercial"} child={"Gestión de Cargos"} />
            <Container maxWidth={false} sx={{ px: 5, py: 5 }}>
              <Box sx={{ minHeight: '100vh', backgroundColor: '#fff', fontFamily: 'Inter, "Noto Sans", sans-serif' }}>
                <Box maxWidth="lg" mx="auto" py={4}>
                  {/* Header */}
                  <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 3 }}>
                    <Typography variant="h4" fontWeight={600}>
                      Gestión de {capitalize(cargoDetalle?.nombre)}
                    </Typography>
                    <Button
                      variant="outlined"
                      startIcon={<RefreshIcon />}
                      
                    >
                      Actualizar
                    </Button>
                  </Stack>
                  
                  {/* Error Alert */}
                  {error && (
                    <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError('')}>
                      {error}
                    </Alert>
                  )}
                  
                  {/* Summary Cards */}
                  <Grid container spacing={2} sx={{ mb: 3 }}>
                    <Grid item xs={12} sm={3}>
                      <Card sx={{ backgroundColor: '#fff3e0' }}>
                        <CardContent>
                          <Typography variant="subtitle1" color="warning.main">
                            Pendientes
                          </Typography>
                          <Typography variant="h5" fontWeight="bold" color="warning.main">
                            {filteredProductos.filter(c => c.estado === 'pendiente').length}
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <Card sx={{ backgroundColor: '#e8f5e8' }}>
                        <CardContent>
                          <Typography variant="subtitle1" color="success.main">
                            Recibidos
                          </Typography>
                          <Typography variant="h5" fontWeight="bold" color="success.main">
                            {gestionCargos.filter(c => c.estado === 'recibido').length}
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>


                  {/* Content */}
                  <Box>
                      {/* Filters */}
                      <Paper sx={{ p: 2, mb: 3 }}>
                        <Grid container spacing={2} alignItems="center">
                          <Grid item size={4}>
                            <TextField
                              fullWidth
                              placeholder="Buscar por ID de producto o categoría..."
                              value={filters.search}
                              onChange={(e) => setFilters(prev => ({ ...prev, search: e.target.value }))}
                              InputProps={{
                                startAdornment: <SearchIcon sx={{ mr: 1, color: 'text.secondary' }} />
                              }}
                            />
                          </Grid>
                          <Grid item size={3}>
                            <FormControl fullWidth>
                              <Selector
                                sx={{backgroundColor: 'white'}}
                                value={filters.estado}
                                onChange={(e) => setFilters(prev => ({ ...prev, estado: e.target.value }))}
                                placeholder="Estado"    
                              >
                              </Selector>
                            </FormControl>
                          </Grid>
                          <Grid item size={3}>
                            <FormControl fullWidth>
                              <Selector
                                sx={{backgroundColor: 'white'}}
                                value={filters.sucursal}
                                onChange={(e) => setFilters(prev => ({ ...prev, sucursal: e.target.value }))}
                                placeholder="Sucursal"
                              >
                              </Selector>
                            </FormControl>
                          </Grid>
                          <Grid item size={2}>
                            <Button
                              variant="outlined"
                              startIcon={<ClearIcon />}
                              onClick={handleClearFilters}
                              fullWidth
                            >
                              Limpiar
                            </Button>
                          </Grid>
                        </Grid>
                      </Paper>
                      
                      {/* Data Table */}
                      <Paper sx={{ borderRadius: 2, boxShadow: 'none' }}>
                        {filteredProductos.length === 0 ? (
                          <Box sx={{ 
                            height: 400, 
                            display: 'flex', 
                            flexDirection: 'column', 
                            alignItems: 'center', 
                            justifyContent: 'center',
                            p: 3
                          }}>
                            <Typography variant="h6" color="text.secondary" gutterBottom>
                              No se encontraron cargos
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              {filters.search || filters.estado || filters.sucursal
                                ? 'Intenta ajustar los filtros'
                                : 'No hay cargos pendientes de recepción'
                              }
                            </Typography>
                          </Box>
                        ) : (
                          <TableContainer sx={{ borderRadius: 2 }}>
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <StyledCellHeader>ID del Producto</StyledCellHeader>
                                  <StyledCellHeader>Estado</StyledCellHeader>
                                  <StyledCellHeader>Categoría</StyledCellHeader>
                                  <StyledCellHeader>Inventario</StyledCellHeader>
                                  <StyledCellHeader>Sucursal</StyledCellHeader>
                                  <StyledCellHeader>Acciones</StyledCellHeader>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {filteredProductos.map((producto) => (
                                  <TableRow key={producto.id}>
                                    <TableCell>
                                      <Typography variant="body2" fontWeight={500}>
                                        {producto.id}
                                      </Typography>
                                    </TableCell>
                                    <TableCell>
                                      <Chip 
                                        label={gestionCargos.find(c => c.id_producto === producto.id) == null?'pendiente':gestionCargos.find(c => c.id_producto === producto.id)?.estado}
                                        color={ESTADOS[gestionCargos.find(c => c.id_producto === producto.id) == null?'pendiente':gestionCargos.find(c => c.id_producto === producto.id)?.estado]?.color}
                                        size="small"
                                        icon={ESTADOS[gestionCargos.find(c => c.id_producto === producto.id) == null?'pendiente':gestionCargos.find(c => c.id_producto === producto.id)?.estado]?.icon}
                                      />
                                    </TableCell>
                                    <TableCell>
                                      <Chip 
                                        label={producto.categoria_name}
                                        color="primary"
                                        size="small"
                                      />
                                    </TableCell>
                                    <TableCell>{producto.categoria_name}</TableCell>
                                    <TableCell>{producto.sucursal}</TableCell>
                                    <TableCell>
                                      <Stack direction="row" spacing={1}>
                                        {(gestionCargos.find(c => c.id_producto === producto.id)?.estado === 'pendiente') || (gestionCargos.find(c => c.id_producto === producto.id) == null) && (
                                          <Tooltip title="Recibir">
                                            <IconButton 
                                              size="small" 
                                              onClick={() => handleReception(producto)}
                                              color="success"
                                            >
                                              <CheckCircleOutlineOutlined fontSize="small" />
                                            </IconButton>
                                          </Tooltip>
                                        )}
                                        <Tooltip title="Ver detalles">
                                          <IconButton 
                                            size="small" 
                                            color="primary"
                                          >
                                            <RemoveRedEyeOutlined fontSize="small" />
                                          </IconButton>
                                        </Tooltip>
                                      </Stack>
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        )}
                      </Paper>
                    </Box>
                </Box>
              </Box>
            </Container>
          </Stack>
        </Box>
      </Box>
      
      {/* Reception Dialog */}
      <Dialog 
        open={showReceptionDialog} 
        onClose={() => setShowReceptionDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Typography variant="h6" fontWeight={600}>
            Recepcion de {cargoDetalle?.nombre}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Stack spacing={3} sx={{ mt: 1 }}>
            <Typography variant="body2" color="text.secondary">
                Recibir {cargoDetalle?.nombre} <strong>{selectedCargo?.id}</strong> - <strong>{selectedCargo?.categoria_name}</strong>
            </Typography>
            
            <TextField
              fullWidth
              placeholder="Numeración"
              value={receptionData.numeracion}
              onChange={(e) => setReceptionData(prev => ({ ...prev, numeracion: e.target.value }))}
            />
            
            <TextField
              fullWidth
              placeholder="Comentarios adicionales sobre la recepción..."
              value={receptionData.comentario}
              onChange={(e) => setReceptionData(prev => ({ ...prev, comentario: e.target.value }))}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowReceptionDialog(false)}>
            Cancelar
          </Button>
          <Button 
            variant="contained" 
            onClick={handleReceptionSubmit}
            color="primarybutton"
            sx={{fontWeight:"bold"}}
            disabled={!receptionData.numeracion}
          >
            Recibir
          </Button>
        </DialogActions>
      </Dialog>

      {/* Alert Message Dialog */}
      <AlertMessageDialog
        open={alertOpen}
        setOpen={setAlertOpen}
        title={alertTitle}
        message={alertMessage}
        severity={alertSeverity}
        handleClose={handleCloseAlert}
      />

    </AppTheme>
  );
};

export default GestionComercialCargos;
